import { createHandlerChainRunner, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { CreateShipToApiParameter, validateOneTimeAddress } from "@tKgpco/Services/OneTimeShippingService";
import { getReportHistory, loadReportsParams, OrderHistoryResultModel } from "@tKgpco/Services/ReportsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<CreateShipToApiParameter & HasOnComplete, string>;

export const DispatchBeginValidateOneTimeAddress: HandlerType = props => {
    props.dispatch({ type: "Custom/CheckoutShipping/UsAddressValidateLoading" });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await validateOneTimeAddress(props.parameter);
};

export const DispatchCompleteValidateOneTimeAddress: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutShipping/UsAddressValidateError",
        errorMessage: props.apiResult,
    });
};

export const chain = [DispatchBeginValidateOneTimeAddress, RequestDataFromApi, DispatchCompleteValidateOneTimeAddress];

export const validateOneTimeAddressHandler = createHandlerChainRunner(chain, "validateOneTimeAddressHandler");
export default validateOneTimeAddressHandler;
